import AddNewPage from './AddNewPage';
export default AddNewPage;
